'use strict';

/* ========================================================
 * 		Requires
 ========================================================= */
// Polyfills
require('./polyfills/requestAnimationFrame.js');

// JQuery, and Animation Code
var $ = window.jQuery = window.$ = require('jquery');
var jqueryMigrate = require('jquery-migrate');
$.migrateMute = true;

var Analytics = require('@plaudit/analytics').Analytics;
window.plauditAnalytics = Analytics.getInstance();

// Lib
require('./lib/a4jAjaxEvents.js');
require('./lib/third-party/jquery.cycle.js');
require('./lib/third-party/jquery-ui.js');
require('./lib/third-party/plugins.js');

// Components
require('./components/DonateToProject.js');
var DonateFunds = require('./components/DonateFunds.js');
var BookCounter = require('./components/BookCounter.js');

// Site
require('./site/global.js');
window.plauditUI = require('./site/site.js');


/* ========================================================
 * 		Setup
 ========================================================= */
var $win = $(window);
var $body = $(document.body);


/* ========================================================
 * 		Component Setup
 ========================================================= */
DonateFunds.init();
BookCounter.init();
require('./components/Newsroom.js').init();
require('./components/NewsArticle.js').init();
require('./components/Landing.js').init();
require('./components/ExitIntent.js').init();
